import { toast } from "$global-providers/toast-provider";
import { PayerType } from "elephant-web/gql";
import { useCallback, useState } from "react";
import {
  type TakePaymentMutationVariables,
  useTakePaymentMutation,
} from "./__generated__/useTakePayment.gql";

export const transformExemptTransactions = ({
  reason,
  currency,
  totalPayableInPence,
}): TakePaymentMutationVariables["input"]["transactions"] => [
  {
    payer: {
      type: PayerType.Exempt,
      name: reason,
    },
    amount: {
      value: totalPayableInPence,
      currency,
    },
    payment: null,
  },
];

export default function useExemptPayment(invoiceId: string) {
  const [saving, setSaving] = useState<boolean>(false);
  const [saved, setSaved] = useState<boolean>(false);

  const [makePayment] = useTakePaymentMutation({
    onError(err) {
      toast.error(err.message);
    },
    onCompleted() {
      setSaving(false);
      setSaved(true);
    },
  });

  const exemptPayment = useCallback(
    async ({ reason, currency, totalPayableInPence }) => {
      setSaving(true);
      makePayment({
        variables: {
          input: {
            _id: invoiceId,
            transactions: transformExemptTransactions({
              reason,
              currency,
              totalPayableInPence,
            }),
          },
        },
      });
    },
    [makePayment, invoiceId],
  );

  return { exemptPayment, saving, saved };
}
